import CatalogPhaseEvents from "@/pages/eaf/catalogs/phase-events";
import {
	Divider,
	List,
	ListItem,
	ListItemText,
	ListSubheader,
	useTheme,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import AlertLimit from "../pages/caster/alert/AlertLimit";
import CatalogMoldSize from "../pages/caster/catalogs/mold-sizes";
import CatalogMold from "../pages/caster/catalogs/molds";
import CatalogCategories from "../pages/delays/categories";
import DelayCodePage from "../pages/delays/codes";
import CatalogElement from "../pages/laboratory/catalogs/elements";
import CatalogMechanicalTest from "../pages/laboratory/catalogs/mechanicalTest";
import CatalogResultSource from "../pages/laboratory/catalogs/resultSource";
import CatalogSampleType from "../pages/laboratory/catalogs/sampleType";
import CatalogBuckets from "../pages/steel/catalogs/buckets";
import CatalogGrade from "../pages/steel/catalogs/grade";
import CatalogLadle from "../pages/steel/catalogs/ladle";
import CatalogMaterial from "../pages/steel/catalogs/materials";
import CatalogSection from "../pages/steel/catalogs/section";

const components = [
	{
		path: "alerts",
		sidebar: () => <div>alerts</div>,
		main: () => <AlertLimit />,
	},
	{
		path: "lab-element",
		sidebar: () => <div>elements</div>,
		main: () => <CatalogElement />,
	},
	{
		path: "lab-mechanical-test",
		sidebar: () => <div>mechanical tests</div>,
		main: () => <CatalogMechanicalTest />,
	},
	{
		path: "lab-result-source",
		sidebar: () => <div>result sources</div>,
		main: () => <CatalogResultSource />,
	},
	{
		path: "lab-sample-type",
		sidebar: () => <div>sample types</div>,
		main: () => <CatalogSampleType />,
	},
	{
		path: "caster-molds",
		sidebar: () => <div>Molds</div>,
		main: () => <CatalogMold />,
	},
	{
		path: "caster-mold-sizes",
		sidebar: () => <div>Mold Sizes</div>,
		main: () => <CatalogMoldSize />,
	},
	{
		path: "eaf-phase-events",
		sidebar: () => <div>Phase Events</div>,
		main: () => <CatalogPhaseEvents />,
	},
	{
		path: "steel-grade",
		sidebar: () => <div>grades</div>,
		main: () => <CatalogGrade />,
	},
	{
		path: "steel-grade/:gradeId",
		sidebar: () => <div>grades</div>,
		main: () => <CatalogGrade />,
	},
	{
		path: "steel-ladle",
		sidebar: () => <div>ladles</div>,
		main: () => <CatalogLadle />,
	},
	{
		path: "steel-section",
		sidebar: () => <div>sections</div>,
		main: () => <CatalogSection />,
	},
	{
		path: "steel-material",
		sidebar: () => <div>materials</div>,
		main: () => <CatalogMaterial />,
	},
	{
		path: "steel-buckets",
		sidebar: () => <div>buckets</div>,
		main: () => <CatalogBuckets />,
	},
	{
		path: "delay-categories",
		sidebar: () => <div>Delay Categories</div>,
		main: () => <CatalogCategories />,
	},
	{
		path: "delay-codes-eaf",
		sidebar: () => <div>EAF Delay Codes</div>,
		main: () => <DelayCodePage delayAreaAssetName="EAF" />,
	},
	{
		path: "delay-codes-caster",
		sidebar: () => <div>CASTER Delay Codes</div>,
		main: () => <DelayCodePage delayAreaAssetName="Caster" />,
	},
];

const sidebar = ({ option }: { option: string }) => {
	const theme = useTheme();
	const listSubheaderStyle = {
		backgroundColor: theme.palette.background.paper,
		color: theme.palette.primary.main,
		fontWeight: 600,
	};
	return (
		<>
			<List
				subheader={
					<ListSubheader style={listSubheaderStyle}>Laboratory</ListSubheader>
				}
			>
				<ListItem
					button
					selected={option === "lab-element"}
					component={Link}
					to="/configuration/lab-element"
				>
					<ListItemText primary="Elements" />
				</ListItem>
				<ListItem
					button
					selected={option === "lab-mechanical-test"}
					component={Link}
					to="/configuration/lab-mechanical-test"
				>
					<ListItemText primary="Mechanical Tests" />
				</ListItem>
				<ListItem
					button
					selected={option === "lab-result-source"}
					component={Link}
					to="/configuration/lab-result-source"
				>
					<ListItemText primary="Result Sources" />
				</ListItem>
				<ListItem
					button
					selected={option === "lab-sample-type"}
					component={Link}
					to="/configuration/lab-sample-type"
				>
					<ListItemText primary="Sample Types" />
				</ListItem>
			</List>
			<Divider />
			<List
				subheader={
					<ListSubheader style={listSubheaderStyle}>Caster</ListSubheader>
				}
			>
				<ListItem
					button
					selected={option === "caster-molds"}
					component={Link}
					to="/configuration/caster-molds"
				>
					<ListItemText primary="Molds" />
				</ListItem>
				<ListItem
					button
					selected={option === "caster-mold-sizes"}
					component={Link}
					to="/configuration/caster-mold-sizes"
				>
					<ListItemText primary="Mold Sizes" />
				</ListItem>
			</List>
			<Divider />
			<List
				subheader={
					<ListSubheader style={listSubheaderStyle}>Steel</ListSubheader>
				}
			>
				<ListItem
					button
					selected={option === "steel-grade"}
					component={Link}
					to="/configuration/steel-grade"
				>
					<ListItemText primary="Grades" />
				</ListItem>
				<ListItem
					button
					selected={option === "steel-ladle"}
					component={Link}
					to="/configuration/steel-ladle"
				>
					<ListItemText primary="Ladles" />
				</ListItem>
				<ListItem
					button
					selected={option === "steel-section"}
					component={Link}
					to="/configuration/steel-section"
				>
					<ListItemText primary="Sections" />
				</ListItem>
				<ListItem
					button
					selected={option === "steel-material"}
					component={Link}
					to="/configuration/steel-material"
				>
					<ListItemText primary="Materials" />
				</ListItem>
				<ListItem
					button
					component={Link}
					to="/configuration/eaf-phase-events"
					selected={option === "eaf-phase-events"}
				>
					<ListItemText primary="Phase Events" />
				</ListItem>
				<ListItem
					button
					selected={option === "steel-buckets"}
					component={Link}
					to="/configuration/steel-buckets"
				>
					<ListItemText primary="Buckets" />
				</ListItem>
			</List>
			<Divider />
			<List
				subheader={
					<ListSubheader style={listSubheaderStyle}>Settings</ListSubheader>
				}
			>
				<ListItem
					button
					selected={option === "alerts"}
					component={Link}
					to="/configuration/alerts"
				>
					<ListItemText primary="Alerts" />
				</ListItem>
			</List>
			<Divider />
			<List
				subheader={
					<ListSubheader style={listSubheaderStyle}>Delays</ListSubheader>
				}
			>
				<ListItem
					button
					selected={option === "delay-categories"}
					component={Link}
					to="/configuration/delay-categories"
				>
					<ListItemText primary="Categories" />
				</ListItem>
				<ListItem
					button
					selected={option === "delay-codes-eaf"}
					component={Link}
					to="/configuration/delay-codes-eaf"
				>
					<ListItemText primary="EAF Codes" />
				</ListItem>
				<ListItem
					button
					selected={option === "delay-codes-caster"}
					component={Link}
					to="/configuration/delay-codes-caster"
				>
					<ListItemText primary="Caster Codes" />
				</ListItem>
			</List>
		</>
	);
};

const customConfigurations = [components, sidebar];

export { customConfigurations };
